import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

export const THROTTLE_WAIT = 100;
export const SEARCH_BAR = 'SearchBar';

export const insurancePickerPropsShape = PropTypes.shape({
    carrierId: PropTypes.string,
    'data-test': PropTypes.string,
    errorStateOverride: PropTypes.bool,
    onChange: PropTypes.func,
    planId: PropTypes.string,
    showScanInsuranceCardButton: PropTypes.bool,
});

export const locationPickerPropsShape = PropTypes.shape({
    'data-test': PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
});

export const ppsUniversalSearchPropsShape = PropTypes.shape({
    additionalQueryParameters: PropTypes.shape({
        namedSearchFiltering: PropTypes.number,
        separateSemanticIndex: PropTypes.number,
        trimResults: PropTypes.number,
        useMostPopular: PropTypes.number,
    }),
    carrierId: PropTypes.string,
    'data-test': PropTypes.string,
    directoryId: PropTypes.string,
    enableBrowseSpecialtyForMobile: PropTypes.bool,
    enablePrefixSearch: PropTypes.bool,
    enableSemanticSpecialty: PropTypes.bool,
    isMobile: PropTypes.bool,
    onSelectOption: PropTypes.func,
    page: PropTypes.string,
    planId: PropTypes.string,
    searchApiUrl: PropTypes.string,
    searchApiV2Url: PropTypes.string,
    sessionId: PropTypes.string,
    trackingId: PropTypes.string,
    useElasticGrouping: PropTypes.bool,
});

export const SearchApiEndpoint = '/directory/v1/providers/autocomplete';
export const SearchApiV2Endpoint = '/directory/v2/providers/autocomplete';

export const LOCALIZED_STRINGS = defineMessages({
    Close: {
        id: 'SearchBarView.Close',
        defaultMessage: 'close',
    },
    Location: {
        id: 'SearchBarView.Location',
        defaultMessage: 'location',
    },
    FindDoctors: {
        id: 'SearchBarView.FindDoctors',
        defaultMessage: 'Find doctors',
    },
    Insurance: {
        id: 'SearchBarView.Insurance',
        defaultMessage: 'insurance',
    },
    Search: {
        id: 'SearchBarView.Search',
        defaultMessage: 'search',
    },
    Greeting: {
        id: 'MyAccounts.SearchBarView.Greeting',
        defaultMessage: 'Hey {firstName},',
    },
    GreetingMessage: {
        id: 'MyAccounts.SearchBarView.GreetingMessage',
        defaultMessage: 'Let\'s help you stay on top of your health',
    },
});
